import Handlebars from "handlebars";

Handlebars.registerHelper("titleize", function (string) {
  string = string.replace("_", " ");
  return string.charAt(0).toUpperCase() + string.slice(1);
});
